<section class="rich-editor" [class.is-disabled]="disabled">
  <header class="rich-editor-toolbar" role="toolbar" aria-label="Outils d'edition">
    <div class="toolbar-group">
      <button type="button" class="toolbar-btn" [class.active]="isCommandActive('bold')" [disabled]="disabled" (mousedown)="preventToolbarFocus($event)" (click)="applyCommand('bold')">Gras</button>
      <button type="button" class="toolbar-btn" [class.active]="isCommandActive('italic')" [disabled]="disabled" (mousedown)="preventToolbarFocus($event)" (click)="applyCommand('italic')">Italique</button>
      <button type="button" class="toolbar-btn" [class.active]="isCommandActive('underline')" [disabled]="disabled" (mousedown)="preventToolbarFocus($event)" (click)="applyCommand('underline')">Souligné</button>
    </div>

    <div class="toolbar-group">
      <button type="button" class="toolbar-btn" [disabled]="disabled" (mousedown)="preventToolbarFocus($event)" (click)="undo()">Annuler</button>
      <button type="button" class="toolbar-btn" [disabled]="disabled" (mousedown)="preventToolbarFocus($event)" (click)="redo()">Rétablir</button>
      <button type="button" class="toolbar-btn" [disabled]="disabled" (mousedown)="preventToolbarFocus($event)" (click)="insertOrderedList()">Liste ordonnée</button>
      <button type="button" class="toolbar-btn" [disabled]="disabled" (mousedown)="preventToolbarFocus($event)" (click)="insertUnorderedList()">Liste à puces</button>
    </div>

    <div class="toolbar-group">
      <button type="button" class="toolbar-btn" [class.active]="isCommandActive('justifyLeft')" [disabled]="disabled" (mousedown)="preventToolbarFocus($event)" (click)="alignLeft()">Gauche</button>
      <button type="button" class="toolbar-btn" [class.active]="isCommandActive('justifyCenter')" [disabled]="disabled" (mousedown)="preventToolbarFocus($event)" (click)="alignCenter()">Centré</button>
      <button type="button" class="toolbar-btn" [class.active]="isCommandActive('justifyRight')" [disabled]="disabled" (mousedown)="preventToolbarFocus($event)" (click)="alignRight()">Droite</button>
    </div>

    <div class="toolbar-group toolbar-group-selects">
      <select class="toolbar-select" [value]="currentBlockFormat" [disabled]="disabled" (mousedown)="captureSelection()" (change)="applyBlockFormat(($any($event.target)).value)">
        @for (option of blockFormats; track option.value) {
          <option [value]="option.value">{{ option.label }}</option>
        }
      </select>

      <label class="toolbar-font-size">
        Taille
        <input
          #fontSizeInput
          class="toolbar-number"
          type="number"
          [value]="currentFontSizePx"
          [disabled]="disabled"
          min="8"
          max="72"
          step="1"
          (mousedown)="rememberSelection()"
        />
        <span class="toolbar-font-size-unit">px</span>
        <button
          type="button"
          class="toolbar-btn"
          [disabled]="disabled"
          (mousedown)="preventToolbarFocus($event)"
          (click)="applyFontSizePx(fontSizeInput.value)"
        >Appliquer</button>
      </label>
    </div>

    <div class="toolbar-group">
      <button type="button" class="toolbar-btn" [disabled]="disabled" (mousedown)="preventToolbarFocus($event)" (click)="insertLink()">Lien</button>
      <button type="button" class="toolbar-btn" [disabled]="disabled" (mousedown)="preventToolbarFocus($event)" (click)="insertTable()">Tableau</button>
      <button type="button" class="toolbar-btn" [disabled]="disabled" (mousedown)="preventToolbarFocus($event)" (click)="triggerImagePicker()">Image</button>
    </div>
  </header>

  <div
    #editor
    class="rich-editor-canvas"
    [attr.data-placeholder]="placeholder"
    [attr.contenteditable]="!disabled"
    [attr.aria-label]="label"
    role="textbox"
    aria-multiline="true"
    spellcheck="true"
    (input)="handleInput()"
    (blur)="handleBlur()"
    (focus)="captureSelection()"
    (keyup)="captureSelection()"
    (mouseup)="captureSelection()"
    (contextmenu)="handleEditorContextMenu($event)"
  ></div>

  @if (cellAlignMenuOpen) {
    <div
      class="cell-align-menu"
      [style.left.px]="cellAlignMenuX"
      [style.top.px]="cellAlignMenuY"
      (click)="keepCellAlignMenuOpen($event)"
    >
      <div class="cell-align-menu-header">
        <h4 class="cell-align-menu-title">Alignement</h4>
        <button type="button" class="cell-align-menu-close" aria-label="Fermer" (click)="closeCellAlignMenu()">×</button>
      </div>
      <button type="button" class="cell-align-menu-btn" (click)="setCellVerticalAlign('top')">Aligner en haut</button>
      <button type="button" class="cell-align-menu-btn" (click)="setCellVerticalAlign('middle')">Aligner au centre</button>
      <button type="button" class="cell-align-menu-btn" (click)="setCellVerticalAlign('bottom')">Aligner en bas</button>
      <div class="cell-align-menu-separator" aria-hidden="true"></div>
      <button type="button" class="cell-align-menu-btn" (click)="openTablePropertiesDialog()">Propriétés du tableau</button>
      <button type="button" class="cell-align-menu-btn danger" (click)="deleteSelectedTable()">Supprimer le tableau</button>
    </div>
  }

  @if (tableDialogOpen) {
    <div class="table-dialog-overlay">
      <div class="table-dialog" (click)="$event.stopPropagation()">
        <div class="table-dialog-header">
          <h3 class="table-dialog-title">{{ tableDialogMode === 'update' ? 'Propriétés du tableau' : 'Insertion de tableau' }}</h3>
          <button type="button" class="table-dialog-close" aria-label="Fermer" (click)="cancelInsertTable()">×</button>
        </div>

        <label class="table-dialog-field">
          <span>Nombre de lignes</span>
          <input type="number" min="1" max="20" step="1" [(ngModel)]="tableRowsInput" />
        </label>

        <label class="table-dialog-field">
          <span>Nombre de colonnes</span>
          <input type="number" min="1" max="20" step="1" [(ngModel)]="tableColsInput" />
        </label>

        <label class="table-dialog-field">
          <span>Couleur de bordure</span>
          <input type="color" [(ngModel)]="tableBorderColor" />
        </label>

        <label class="table-dialog-field">
          <span>Largeur bordure (px)</span>
          <input type="number" min="1" max="20" step="1" [(ngModel)]="tableBorderWidthPx" />
        </label>

        <label class="table-dialog-checkbox">
          <input type="checkbox" [(ngModel)]="tableShowBorders" />
          <span>Voir les bordures</span>
        </label>

        <div class="table-dialog-actions">
          <button type="button" class="toolbar-btn" (click)="confirmInsertTable()">{{ tableDialogMode === 'update' ? 'Mettre à jour' : 'Insérer' }}</button>
          <button type="button" class="toolbar-btn" (click)="cancelInsertTable()">Annuler</button>
        </div>
      </div>
    </div>
  }

  <input #imageInput type="file" accept="image/*" hidden (change)="handleImageSelection($event)" />
</section>